import InputWithRegex from './InputWithRegex';
export default InputWithRegex;
